module.exports = __webpack_public_path__ + "img/avatar4.4d12ba84.png";